import AppSidebar from './AppSidebar';
import { Navbar } from './common/Catalyst/navbar';
import { SidebarLayout } from './common/Catalyst/sidebar-layout';
import HoaListComponent from './hoa/HoaListComponent';

interface HOAPageProps {
  currentPage: string;
}

const HOAPage: React.FC<HOAPageProps> = ({ currentPage }) => {
  return (
    <SidebarLayout
      sidebar={<AppSidebar currentPage={currentPage} />}
      navbar={<Navbar>{/* Your navbar content */}</Navbar>}
      // The list uses the whole panel and scrolls inside itself, with its
      // filter bar as the top row, like violations and work orders.
      fill
      flush
    >
      {/* No page heading: the sidebar already says where you are. */}
      <HoaListComponent />
    </SidebarLayout>
  );
};

export default HOAPage;
